import request from "./requestConfig";

const apiList = {
  //用户名密码登录
  login(data) {
    return request({
      url: "/user/login",
      method: "post",
      data,
    });
  },
  //获取微信登录二维码内容 ，根据内容生成二维码
  getWxQrCodeContent(data) {
    return request({
      url: "/v2/wechat/login/qrcode",
      method: "get",
      data,
    });
  },
  //微信登录接口  需要轮询,成功之后进入系统
  wxLogin(data) {
    return request({
      url: "/v2/wechat/login",
      method: "get",
      data,
    });
  },
  getWorkBench() {
    return request({
      url: "/v2/users/work-bench",
      method: "get",
    });
  },
  // 获取版本信息
  getAppVersion() {
    return request({
      url: "/v2/applications/versions",
      method: "get",
    });
  },
  //获取登录页面系统配置
  getLoginPageConfig() {
    return request({
      url: "/v2/configs/login",
      method: "get",
    });
  },
  //获取google系统配置
  getSystemGoogleConfig() {
    return request({
      url: "/v2/configs/system/userLoginGoogle",
      method: "get",
    });
  },

  //Google登录
  googleLogin(data) {
    return request({
      url: "/v2/google",
      method: "get",
      data,
    });
  },

  // 获取二维码内容
  getGoogleQrCodeContent(data) {
    return request({
      url: "/v2/google/secret",
      method: "get",
      data,
    });
  },

  // google绑定
  googleBind(data) {
    return request({
      url: "/v2/google",
      method: "post",
      data,
    });
  },
  //登出接口
  logout() {
    return request({
      url: "/user/logout",
      method: "get",
    });
  },

  //根据配置名称获取某配置
  getConfigByName(config) {
    return request({
      url: `/v2/configs/system/${config}`,
      method: "get",
    });
  },

  // 获取所有语言
  getLanguageList() {
    return request({
      url: "/v2/i18n",
      method: "get",
    });
  },

  // 获取运行中的插件信息
  getRunningPluginInfo() {
    return request({
      url: `/v2/plugins/status/installed`,
      method: "get",
    });
  },

  //*************** 收件箱相关**************************** */
  //  获取收件箱列表
  getInboxMessageList(data) {
    return request({
      url: `/v2/users/inbox`,
      method: "get",
      data,
    });
  },
  // 获取消息详情
  getMessageDetails(id, data) {
    return request({
      url: `/v2/users/inbox/${id}`,
      method: "get",
      data,
    });
  },
  //  将消息设置为已读
  readMessage(data) {
    return request({
      url: `/v2/users/inbox/${data}/read`,
      method: "get",
    });
  },
  // 单个附件下载
  getAttach(noticeId, data) {
    return request({
      url: `/v2/notice/${noticeId}/attaches`,
      method: "get",
      responseType: "blob",
      data,
    });
  },
  // 消息全部已读
  readAllMessage() {
    return request({
      url: `/v2/users/inbox/read/all`,
      method: "get",
    });
  },
  // 请求是否上传license
  isHaveLicense() {
    return request({
      url: `/v2/licenses`,
      method: "get",
    });
  },
  // 返回上传license文件的动作actionId
  getActionId(data) {
    return request({
      url: "/v2/licenses",
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data,
    });
  },
  // 上传license文件
  uploadLicense(actionId) {
    return request({
      url: `/v2/licenses/upload/${actionId}`,
      method: "get",
    });
  },

  //azure login
  azureLogin() {
    return request({
      url: `/azure/v2/login`,
      method: "get",
    });
  },

  // 获取密码规则
  getPwdStrength() {
    return request({
      url: "/v2/users/password-strength",
      method: "get",
    });
  },
  // 查询指定用户
  getUserInfo() {
    return request({
      url: "/v2/users/information",
      method: "get",
    });
  },

  /** 修改用户密码 */
  updateUserOwnPwd(data) {
    return request({
      url: "/v3/users/password/first-time",
      method: "put",
      data,
    });
  },

  // 获取文件上传大小限制
  getUploadFileSizeLimit() {
    return request({
      url: `/v2/utils/max-file-size`,
      method: "get",
    });
  },
  loginWithSso(type,code){
    return request({
      url:`/v2/sso/${type}/token?code=${code}`,
      method:"get"
    })
  },
  checkUserPassword(oldPwd){
    return request({
      url:'/v2/users/password/check',
      method:'post',
      data:{oldPwd}
    })
  },
  getLoginCode(width,oldCaptchaId){
    let oldVal = oldCaptchaId?('&oldCaptchaId='+oldCaptchaId):''
    return request({
      url:`/v2/utils/captcha?width=${width}${oldVal}`,
      method:'get'
    })
  },
  forgetPassword(data){
    return request({
      url:'/v3/users/password-retrieval' ,
      method:'post',
      data
    })
  },
  validateVerficationCode(data){
    return request({
      url:'/v2/utils/captcha-validate' ,
      method:'get',
      data
    })
  },
  getFindPasswordUser(data){
    return request({
      url:'/v3/users/password-strength/acquire',
      headers: { 'Content-Type': 'text/plain' }, // 根据需要设置正确的 Content-Type
      method:'post',
      data
    })
  },
  
  /**
   * 找回密码/激活用户时更新用户密码
   * {
   *  "randomString":"",
   *  "username":"",
   *  "newPwd":""
   * }
   */
  updateUserPassword(data){
    return request({
      url:'/v3/users/password',
      method:'put',
      data
    })
  }
};

export default apiList;
